import {viewModel} from "@/class/view-model";
import store from "@/store/store";
import {Media} from "@/class/data-type";

export class panorama extends viewModel{
    
    objectType = "panorama";
    
    /**
     * variables de données
     */
    
    data = [
        {name: "name", type: String, default: "A renseigner"},
        {name: "title", type: String, default: ""},
        {name: "intro_subtitle", type: String, default: ""},
        {name: "intro_text", type: String, default: ""},
        {name: "intro_image", type: Media, default: new Media({type:"picture"})},
        {name: "is_intro_pano", type: Boolean, default: false},
    ]
    
    constructor() {
        super();
        this.init()
    }
    
    getThumbnail(){
        return this.intro_image.media || store.getters.getDefault("BaseImage");
    }
}